import { TemporalCondition } from '@avantstay/arriere-clients/dist/arriereBackoffice'

export interface FiltersSharedProps {
  label?: string
  isSidebarFilter?: boolean
  isInlineFilter?: boolean
  isAccordionOpen?: boolean
  showFilterAsColumn?: boolean
  disabled?: boolean
  onShowFilterAsColumn?: VoidFunction
}

export interface ObjectFilterProps {
  option?: string
  fromOptionValue?: string
  toOptionValue?: string
}

export interface PeriodFilterRawData {
  period?: string
  periodReference?: TemporalCondition
}

export interface AdvancedFiltersHandlers {
  handleApplyFilters: () => void
}

export enum BookingBackToBackView {
  b2b = 'B2B',
  nonB2b = 'NON_B2B',
}

export enum BookingAcquisitionView {
  allBookings = 'ALL_BOOKINGS',
  onlyAcquisition = 'ONLY_ACQUISITION_BOOKINGS',
  nonAcquisition = 'NON_ACQUISITION_BOOKINGS',
}

export enum BookingRepeatView {
  allGuests = 'ALL_GUESTS',
  repeatGuestsOnly = 'REPEAT_GUESTS_ONLY',
  nonRepeatGuestsOnly = 'NON_REPEAT_GUESTS_ONLY',
}

export interface GeolocationProps {
  latitude?: number
  longitude?: number
}

export interface AddressRadiusProps extends GeolocationProps {
  address?: string
  radius?: number
}
